var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<table class=\"table table-hover\">\n    <thead>\n    <tr>\n        <th>\n            タイトル\n        </th>\n        <th style=\"width: 200px; text-align: right;\">\n            公開日時\n        </th>\n    </tr>\n    </thead>\n    <tbody class=\"announcement-container\"></tbody>\n</table>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./feedback/ui/template/announcement/list.hbs
// module id = 1116
// module chunks = 0